import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { BffVersionService } from '@service/bff-version.service';

@Component({
  selector: 'app-version',
  templateUrl: './app-version.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppVersionComponent {
  @Input() show: boolean = true;

  appVersion: string = environment.version;
  bffVersion$: Observable<string> = this.versionService.getBffVersion();

  constructor(private versionService: BffVersionService) {}
}
